import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import { Modal, Button, Row, Col, Alert, Form, Table } from 'react-bootstrap';
import { convertFrom24To12Format, convertTime12to24 } from '../../../../util/genericDateAndTimeFuncs';
import BuilderDocumentRow from '../BuilderDocumentRow';
import axios from 'axios';
import { EmailBody } from '../../../MortgageAnalyzer/analyzer';
import AnalyzerFuncs from '../../../MortgageAnalyzer/analyzer';
import ReactDOMServer from 'react-dom/server';
import NewScheduleEmail from '../EmailComponents/NewScheduleEmail';
import ReScheduleEmail from '../EmailComponents/ReScheduleEmail';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { displayToastMsg } from "../../../toastMessages/toastmessages";
import { saveEsignFields } from '../../../../fileToolbar/fileToolbarMenuItem';
import Loading from "../../../Loading";
const evenTimes = ['8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM'];
const oddTimes = ['8:30 AM', '9:30 AM', '10:30 AM', '11:30 AM', '12:30 PM', '1:30 PM', '2:30 PM', '3:30 PM', '4:30 PM', '5:30 PM', '6:30 PM'];

export type ScheduleEsignProps = {
    setScheduledTime: (arg0: string) => void;
    onHideModal: () => void;
    getRemoteSigningSchedule: () => void;
    showModal: boolean;
    setShowModal: (arg0: boolean) => void;
    sellerDocs: any;
    sessionInfo: any;
    purchasers: any[];
    clientEmail: { name: string, email: string }[];
    firmName: string;
    projectName: string;
    msgID: string;
    reschedule: boolean;
    packageList: string[];
    address: string;
    vendorFirmName: string;
    clientName: string;
    contractPrice: string;
    deposits: any;
    mortgageinfo: any;
    esignAskfieldsFormData: any;
    initLawyerName: string;
    checkIfAllFieldsAreFilled: () => { isAnyFieldEmpty: boolean; isAnyRelevantGroupEmpty: boolean; };
}

const ScheduleEsign = (props: ScheduleEsignProps) => {
    const [date, setDate] = useState<Date>(new Date());
    const [sessionEndTime, setSessionEndTime] = useState<string>('');
    const [sessionStartTime, setSessionStartTime] = useState<string>('');
    const [currentStep, setCurrentStep] = useState<number>(1);
    const [selectedRows, setSelectedRows] = useState<{ index: number; packageName: string }[]>([]);
    const [buyerEmails, setBuyerEmails] = useState<{ [key: string]: string }>({});
    const [lawyerList, setLawyerList] = useState<any[]>([]);
    const [selectedPosts, setSelectedPosts] = useState<string[]>([]);
    const [scheduleType, setScheduleType] = useState<string>('New Schedule');
    const [link, setLink] = useState<string>('');
    const [useLddPlatform, setUseLddPlatform] = useState<boolean>(true);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    useEffect(() => {
        // Initialize buyerEmails with clientEmail
        if (props.purchasers && props.clientEmail) {
        const initialEmails = props.purchasers.reduce((acc, purchaser) => {
            const matchingEmail = props.clientEmail.find(email => email.name === purchaser.name);
            acc[purchaser.name] = matchingEmail ? matchingEmail.email : '';
            return acc;
        }, {} as { [key: string]: string });

            setBuyerEmails(initialEmails);
        }
        if (props.reschedule) {
            setScheduleType('Re Schedule');
        }
        if (props.showModal) {
            const fetchLawyerList = async () => {
                const LawyerListResponse = await axios.get(
                    `/docsigning/info/inbox/lawyerlist?SessionID=${props.sessionInfo.sid}`
                );
                const lawyerListData = LawyerListResponse.data.data.result.lawyersData;
                setLawyerList(lawyerListData);
            };

            fetchLawyerList();
        }
    }, [props.showModal, props.sessionInfo.sid, props.purchasers, props.clientEmail, props.reschedule]);
    useEffect(() => {
      const defaultSelected = props.sellerDocs
      .map((doc: any, index: number) => ({ index, packageName: doc.filename, signStatus: doc.signStatus }))
      .filter(d => d.signStatus?.toString() !== '1')
      .map(({ index, packageName }) => ({ index, packageName }));

      setSelectedRows(defaultSelected);
      setSelectedPosts(defaultSelected.map(d => d.packageName));
      if (defaultSelected.length == 1) {
        setCurrentStep(2);
      } else {
        setCurrentStep(1);
      }
    }, [props.sellerDocs]);

    const handleCheckboxChange = (index: number, filename: string, isChecked: boolean) => {
      
        setSelectedPosts((prevSelected) => {
            if (isChecked) {
                return [...prevSelected, filename];
            } else {
                return prevSelected.filter((file) => file !== filename);
            }
        });
    };

    const generateHtmlBody = (buyerName: string, meetingLink: string, shortCode: string) => {
      switch (scheduleType) {
        case 'New Schedule':
          return ReactDOMServer.renderToString(<NewScheduleEmail clientName={buyerName} firmName={props.firmName} projectName={props.projectName} sessionDate={`${date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}.`} sessionTime={`${convertFrom24To12Format(sessionStartTime)} to ${convertFrom24To12Format(sessionEndTime)}`} sessionLink={meetingLink} shortCode={shortCode} />);
        case 'Re Schedule':
          return ReactDOMServer.renderToString(<ReScheduleEmail clientName={buyerName} firmName={props.firmName} projectName={props.projectName} sessionDate={`${date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}.`} sessionTime={`${convertFrom24To12Format(sessionStartTime)} to ${convertFrom24To12Format(sessionEndTime)}`} sessionLink={meetingLink} shortCode={shortCode} />);
      }
    };

    const generateSubject = () => {
      switch (scheduleType) {
        case 'New Schedule':
          return 'Your lawyer has scheduled an eSigning session.';
        case 'Re Schedule':
          return 'Your lawyer has rescheduled your eSigning session.';
      }
    };

    const saveSessionDateTime = async () => {
        if (sessionStartTime === '' || sessionEndTime === '') {
            alert('Please select a valid start and end time before saving.');
            return;
        }

        const dayISO = date.toISOString().slice(0, 10); // YYYY-MM-DD (UTC day)
        const startDateTime = `${dayISO}T${sessionStartTime.padStart(5, '0')}:00`;
        const endDateTime = `${dayISO}T${sessionEndTime.padStart(5, '0')}:00`;
        const baseUrl = window.location.origin;
        let meetingLink = `${baseUrl}/client-connect/joinRS?language=EN&meetingid=`;
        let shortCode = '';
        let CertificateDetail = {
          propertyAddress: props.address,
          projectName: props.projectName,
          firmName: props.firmName,
          vendorFirmName: props.vendorFirmName,
          clientName: props.clientName,
          contractPrice: props.contractPrice,
          deposits: props.deposits,
          mortgageinfo: props.mortgageinfo,
        }
        const scheduleSession = async () => {
          const response = await axios.post(
              `/docsigning/info/remotesigning/schedule/${props.msgID}?SessionID=${props.sessionInfo.sid}`,
              {
                startDateTime,
                endDateTime,
                packageList: selectedPosts,
                purchaserlist: buyerEmails,
                selectlawyer: props.initLawyerName,
                reschedule: false,
                CertificateDetail: CertificateDetail,
                MeetingLink: meetingLink,
                useLddPlatform: useLddPlatform,
              }
          );

          meetingLink = `${baseUrl}/client-connect/joinRS?language=EN&meetingid=${response.data.recordset[0].MeetingID}&shortcode=${response.data.recordset[0].Shortcode}`;
          setLink(meetingLink);
          shortCode = response.data.recordset[0].Shortcode;

      };
      const RescheduleSession = async () => {
        const response = await axios.post(
            `/docsigning/info/remotesigning/schedule/${props.msgID}?SessionID=${props.sessionInfo.sid}`,
            {
              startDateTime,
              endDateTime,
              packageList: selectedPosts,
              purchaserlist: buyerEmails,
              selectlawyer: props.initLawyerName,
              reschedule: true,
              CertificateDetail: CertificateDetail,
              MeetingLink: meetingLink,
              useLddPlatform: useLddPlatform,
            }
        );
        const baseUrl = window.location.origin;
        meetingLink = `${baseUrl}/client-connect/joinRS?language=EN&meetingid=${response.data.recordset[0].MeetingID}&shortcode=${response.data.recordset[0].Shortcode}`;
        setLink(meetingLink);
        shortCode = response.data.recordset[0].Shortcode;
    };
      setShowLoading(true);
      props.setShowModal(false);
      if (scheduleType === 'New Schedule') {
        await scheduleSession();
      } else {
        await RescheduleSession();
      }
      for (const [buyerName, email] of Object.entries(buyerEmails)) {
          const emailData: EmailBody = {
              to: email,
              subject: generateSubject(),
              msg: generateHtmlBody(buyerName, meetingLink, shortCode),
              isHTML: true
          };
          try {
              await AnalyzerFuncs.sendOutboundEmail(emailData, props.sessionInfo, async () => {
                  // Callback when email is sent
                displayToastMsg({ id: null, msg: <p>Email sent successfully</p>, type: "success" }, null);


              });
          } catch (err) {
              console.log(err);
              displayToastMsg({ id: null, msg: <p>Email failed to send</p>, type: "error" }, null);
          }
      }
      const {isAnyFieldEmpty, isAnyRelevantGroupEmpty} = props.checkIfAllFieldsAreFilled();
      if (isAnyFieldEmpty || isAnyRelevantGroupEmpty) {
        setShowLoading(false);
        setTimeout(() => window.location.reload(), 1500);
        return;
      }
      try {
        await saveEsignFields(props.msgID, props.sessionInfo.sid, props.esignAskfieldsFormData);
        setTimeout(() => window.location.reload(), 1500);
        setShowLoading(false);
    } catch (saveError) {
        console.error('Save failed:', saveError);
        displayToastMsg({ id: null, msg: <p>Failed to save data</p>, type: "error" }, null);
        setTimeout(() => window.location.reload(), 1500);
        setShowLoading(false);
    }
};

    const getSessionLengths = (sessionTime: string): string[] => {
        const time = new Date();
        let [hours, minutes] = sessionTime.split(':');
        let numHours = parseInt(hours);
        let numMinutes = parseInt(minutes);

        time.setHours(numHours);
        time.setMinutes(numMinutes);

        const plusThirty = `${(time.getMinutes() === 30) ? time.getHours() + 1 : time.getHours()}:${(time.getMinutes() === 0) ? '30' : '00'}`;
        const plusOne = `${(time.getMinutes() === 30) ? time.getHours() + 1 : time.getHours() + 1}:${(time.getMinutes() === 0) ? '00' : '30'}`;
        const plusOneThirty = `${(time.getMinutes() === 30) ? time.getHours() + 2 : time.getHours() + 1}:${(time.getMinutes() === 0) ? '30' : '00'}`;
        const plusTwo = `${(time.getMinutes() === 30) ? time.getHours() + 2 : time.getHours() + 2}:${(time.getMinutes() === 0) ? '00' : '30'}`;

        return [plusThirty, plusOne, plusOneThirty, plusTwo]
    }
    const goToNextStep = () => setCurrentStep((prevStep) => prevStep + 1);
    const goToPreviousStep = () => setCurrentStep((prevStep) => prevStep - 1);



    const handleEmailChange = (buyerName: string, email: string) => {
        setBuyerEmails((prevEmails) => ({
            ...prevEmails,
            [buyerName]: email,
        }));
    };

    // Function to check if all email inputs are filled
    const areAllEmailsFilled = () => {
        
        return props.purchasers.every((purchaser) => {
            const email = buyerEmails[purchaser.name] || (props.clientEmail || []).find(email => email.name === purchaser.name)?.email;
            return email && email.trim() !== '';
        });
    };

    const steps = [
      'Select Packages',
      'Confirm Time',
      'Confirm Participants',
      'Review Session'
    ];

    return (
        <>
    <Modal
      show={props.showModal}
      onHide={props.onHideModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="schedule-session-modal"
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">Schedule Session</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Stepper activeStep={currentStep - 1} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {currentStep === 1 && (
          <div>
            <Table>
            <thead>
              <tr>
                <th>Include</th>
                <th>Name</th>
                <th>Status</th>
                <th>Note</th>
                <th>Posting</th>
              </tr>
            </thead>
            <tbody>

            {props.sellerDocs.map((doc: any, index: number) => (
                <BuilderDocumentRow
                  key={index}
                  FileName={doc.filename}
                  Timestamp={doc.PostingDate}
                  msgID={doc.msgID}
                  signStatus={doc.signStatus}
                  note={doc.note}
                  sid={props.sessionInfo.sid}
                  displayMode={true}
                  onCheckboxChange={(isChecked) => handleCheckboxChange(index, doc.filename, isChecked)}
                  selectedPosts={selectedPosts}
                />
            ))}
              </tbody>
              </Table>
            </div>
        )}

        {currentStep === 2 && (
          <>
            <Row className="mt-3">
              <Col className="col-5 text-center">
                <DatePicker
                  className="session"
                  selected={date}
                  minDate={new Date()}
                  onChange={(newDate) => { setDate(newDate) }}
                  inline
                />
                <p>Eastern Time – US & Canada</p>
              </Col>

              <Col>
                <Form.Label>Schedule session on</Form.Label>
                <h2 className="mb-3">{date.toDateString()}</h2>
                
                {(sessionStartTime && sessionEndTime !== '' &&
                    <Row>
                        <Col xs={3}>
                            <Form.Label>from</Form.Label>
                            <h3>{convertFrom24To12Format(sessionStartTime.toString())}</h3> 
                        </Col>

                        <Col>
                            <Form.Label>to</Form.Label>
                            <h3>{convertFrom24To12Format(sessionEndTime.toString())}</h3>
                        </Col>
                    </Row>
                )}
                
                {sessionStartTime !== ''
                  ? (
                    <>
                      {sessionEndTime === '' && <p>Please select an <b>end</b> time.</p>}
                      <Row>
                        <Col xs={2}>
                          {(sessionEndTime === '') && getSessionLengths(sessionStartTime).map((time, index) => (
                            <React.Fragment key={index + '-session-end-times'}>
                              <Button
                                key={index + '-session-end-button'}
                                onClick={() => setSessionEndTime(time)}
                                variant="link-text"
                                style={{ margin: '0'}}
                              >
                                {convertFrom24To12Format(time)}
                              </Button>
                            </React.Fragment>
                          ))}
                        </Col>
                      </Row>
                    </>
                  )
                  : (
                    <>
                      <p>Please select a <b>Start</b> time.</p>
                      <Row>
                        <Col className="col-2">
                          {evenTimes.map((time, index) => (
                            <React.Fragment key={index + '-even-times'}>
                              <Button
                                key={index + '-even-button'}
                                variant="link-text"
                                style={{ margin: '0'}}
                                onClick={() => {
                                  setSessionStartTime(convertTime12to24(time));
                                }}
                              >
                                {time}
                              </Button>
                            </React.Fragment>
                          ))}
                        </Col>
                        <Col className="col-2">
                          {oddTimes.map((time, index) => (
                            <React.Fragment key={index + '-odd-times'}>
                              <Button
                                key={index + '-odd-button'}
                                variant="link-text"
                                style={{ margin: '0'}}
                                onClick={() => setSessionStartTime(convertTime12to24(time))}
                              >
                                {time}
                              </Button>
                            </React.Fragment>
                          ))}
                        </Col>
                      </Row>
                    </>
                  )}
                
                    {(sessionStartTime !== '' && 
                        <Row className="mt-3">
                            <Col>
                                <a onClick={() => {
                                        setSessionStartTime('');
                                        setSessionEndTime('');
                                    }}
                                    ><i className="fa-regular fa-pencil"></i> Edit
                                </a>
                            </Col>
                        </Row>
                    )}
                <Form.Check
                  type="checkbox"
                  id="use-ldd-platform"
                  defaultChecked={useLddPlatform}
                  label={<>Use LDD's Complimentary Video Platform <span className="text-muted">(Recommended)</span></>}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setUseLddPlatform(true);
                    } else {
                      setUseLddPlatform(false);
                    }
                  }}
                />
              </Col>

            </Row>
          </>
        )}

        {currentStep === 3 && (
            <Row>
              <Col>
                <Modal.Title>Purchaser(s)</Modal.Title>
                <Alert variant="info" className="mb-2">
                Your client(s) will receive an email when this session is booked, and a reminder email 30 minutes before the session's scheduled time. This email will contain their link to the meeting.
                </Alert>

                {props.purchasers.map((purchaser) => {
                    return (
                        <div key={purchaser.name} className="mb-3">
                            <Modal.Title>{purchaser.name}</Modal.Title>
                            <Form.Label>Email Address</Form.Label>
                                <input
                                    type="email"
                                    value={buyerEmails[purchaser.name] || ''}
                                    onChange={(e) => handleEmailChange(purchaser.name, e.target.value)}
                                    className="form-control"
                                />
                        </div>
                    );
                })}
                </Col>

              <Col>
                <Modal.Title>Witness</Modal.Title>
                <div>
                  <Form.Label>Lawyer</Form.Label>
                  <p>{props.initLawyerName}</p>
                </div>
              </Col>
          </Row>
        )}

        {currentStep === 4 && (
          <div>
            <Alert variant="info">
             When you click 'Schedule Session', your client(s) will receive an email invitation.
            </Alert>
            <p><strong>Session Time</strong></p>
            <p style={{ fontWeight: 'bold' }}>
              {`${date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}. ${convertFrom24To12Format(sessionStartTime)} - ${convertFrom24To12Format(sessionEndTime)}`}
            </p>
            <p>Eastern Time – US & Canada</p>
            <p><strong>Participants:</strong></p>
            <ul>
              <li>{props.initLawyerName}</li>
              {props.purchasers.map((purchaser) => {
                return (
                  <li key={purchaser.name}>
                    {purchaser.name} ({buyerEmails[purchaser.name] || 'No Email Provided'})
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-primary" onClick={() => props.setShowModal(false)} style={{ marginRight: 'auto' }}>
            Cancel
        </Button>
        {currentStep > 1 && <Button onClick={goToPreviousStep}>Back</Button>}
        {currentStep < 4 && (
          <Button
            variant="primary"
            disabled={
              (currentStep === 1 && selectedPosts.length === 0) ||
              (currentStep === 2 && (sessionStartTime === '' || sessionEndTime === '')) ||
              (currentStep === 3 && (!props.initLawyerName || !areAllEmailsFilled()))
            }
            onClick={() => goToNextStep()}
          >
            Next
          </Button>
        )}
        {currentStep === 4 && (
          <Button
            variant={sessionStartTime && sessionEndTime !== '' ? 'primary' : 'secondary'}
            onClick={() => saveSessionDateTime()}
          >
            Schedule Session
          </Button>
        )}
      </Modal.Footer>
    </Modal>
    {showLoading && <Loading showMsg={true} extraMsg="Scheduling Remote eSigning Session..." />}
        </>
    );
}

export default ScheduleEsign;
